(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/content/competition-closed-draw-open.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/content/competition-closed-draw-open.js');

'use strict';

const {
  useMemo
} = React;
const {
  clx
} = svs.components.lbUtils;
const {
  formatDate
} = svs.components.lbUtils.helpers.formatDate;
const {
  CompetitionLogo,
  LoginButton,
  PixArea,
  PlayButton,
  TrixaButton,
  VisitGameButton
} = svs.components.marketplaceCompetition.overviewHero.common;
const {
  resolveCompetitionName
} = svs.components.marketplaceCompetition.helpers;
const {
  capitalize,
  ordinalNumber
} = svs.components.marketplaceCompetition.overviewHero.helpers;
const {
  useMobileQuery,
  useTrixa
} = svs.components.marketplaceCompetition.overviewHero.hooks;
const {
  IS_NOT_REGISTERED,
  HAS_NO_CURRENT_BET,
  HAS_CURRENT_BET
} = svs.components.marketplaceCompetition.overviewHero.constants.OverviewUserState;
const UserNotLoggedIn = _ref => {
  let {
    competition
  } = _ref;
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    className: "overview-hero-title"
  }, React.createElement("span", null, "T\xE4vlingen har startat!")), React.createElement(LoginButton, {
    isVisible: true
  })));
};
const UserNotRegistered = _ref2 => {
  let {
    competition,
    compName,
    isMobile,
    showTrixa
  } = _ref2;
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    className: "overview-hero-title"
  }, React.createElement("span", null, "T\xE4vlingen har startat!")), React.createElement("p", {
    className: "overview-hero-sub"
  }, React.createElement("span", null, "Du deltar inte i \xE5rets ".concat(compName, ",")), !isMobile && React.createElement("span", null, "men du kan ist\xE4llet t\xE4vla i antal kickar")), React.createElement(TrixaButton, {
    isVisible: !isMobile,
    onClick: showTrixa
  })));
};
const UserHasNoBet = _ref3 => {
  var _competition$currentD;
  let {
    competition
  } = _ref3;
  const {
    firstDrawNumber,
    currentDrawNumber
  } = (competition === null || competition === void 0 ? void 0 : competition.details) || {};
  const closeTime = (_competition$currentD = competition.currentDraw) !== null && _competition$currentD !== void 0 && _competition$currentD.regCloseTime ? formatDate(competition.currentDraw.regCloseTime, true, true) : null;
  const currentGameTitle = useMemo(() => {
    if (firstDrawNumber && currentDrawNumber) {
      const round = currentDrawNumber - firstDrawNumber + 1;
      return React.createElement(React.Fragment, null, React.createElement("span", null, "L\xE4mna in ditt spel till"), React.createElement("span", null, "".concat(ordinalNumber(round), " omg\xE5ngen")));
    }
    return React.createElement("span", null, "L\xE4mna in ditt spel!");
  }, [currentDrawNumber, firstDrawNumber]);
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    className: "overview-hero-title"
  }, currentGameTitle), closeTime && React.createElement("div", {
    className: "overview-hero-sub-small"
  }, "Spelstopp: ".concat(capitalize(closeTime))), React.createElement(PlayButton, {
    competition: competition
  })));
};
const UserHasBet = _ref4 => {
  var _competition$currentD2;
  let {
    competition
  } = _ref4;
  const {
    firstDrawNumber,
    currentDrawNumber
  } = (competition === null || competition === void 0 ? void 0 : competition.details) || {};
  const closeTime = (_competition$currentD2 = competition.currentDraw) !== null && _competition$currentD2 !== void 0 && _competition$currentD2.regCloseTime ? formatDate(competition.currentDraw.regCloseTime, true, true) : null;
  const currentGameTitle = useMemo(() => {
    if (firstDrawNumber && currentDrawNumber) {
      const round = currentDrawNumber - firstDrawNumber + 1;
      return React.createElement("h2", {
        "aria-label": "Du har l\xE4mnat in spelet till ".concat(ordinalNumber(round), " omg\xE5ngen"),
        className: "overview-hero-title"
      }, React.createElement("span", {
        "aria-hidden": "true"
      }, "Du har l\xE4mnat in spelet till"), React.createElement("span", {
        "aria-hidden": "true"
      }, "".concat(ordinalNumber(round), " omg\xE5ngen")));
    }
    return React.createElement("span", null, "Du har l\xE4mnat in spelet f\xF6r omg\xE5ngen!");
  }, [currentDrawNumber, firstDrawNumber]);
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, currentGameTitle, closeTime && React.createElement("div", {
    className: "overview-hero-sub-small"
  }, "Spelet startar ".concat(capitalize(closeTime))), React.createElement(VisitGameButton, {
    competition: competition
  })));
};
const CompetitionClosedDrawOpen = _ref5 => {
  let {
    branding,
    competition,
    userState
  } = _ref5;
  const compName = resolveCompetitionName(competition);
  const isMobile = useMobileQuery();
  const [showTrixa, Trixa] = useTrixa();
  const renderContentBasedOnUserState = state => {
    switch (state) {
      case IS_NOT_REGISTERED:
        return React.createElement(UserNotRegistered, {
          competition: competition,
          compName: compName,
          isMobile: isMobile,
          showTrixa: showTrixa
        });
      case HAS_NO_CURRENT_BET:
        return React.createElement(UserHasNoBet, {
          competition: competition
        });
      case HAS_CURRENT_BET:
        return React.createElement(UserHasBet, {
          competition: competition
        });
      default:
        return React.createElement(UserNotLoggedIn, {
          competition: competition
        });
    }
  };
  if (Trixa) {
    return React.createElement(Trixa, {
      active: true,
      branding: branding,
      classNames: "competition-overview-hero competition-closed-draw-finalized"
    });
  }
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: clx('competition-overview-hero competition-closed-draw-open', userState)
  }, renderContentBasedOnUserState(userState)), React.createElement(PixArea, {
    branding: branding,
    competition: competition,
    isMobile: isMobile,
    isVisible: userState === HAS_NO_CURRENT_BET
  }));
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.content.CompetitionClosedDrawOpen', CompetitionClosedDrawOpen);

 })(window);